import HolidayCalculator from '../hr-tools/holiday-calculator';
import HolidayHourlyCalculator from '../hr-tools/holiday-hourly-calculator';
import HolidayPayCalculator from '../hr-tools/holiday-pay-calculator';

window.HolidayCalculator = window.HolidayCalculator || HolidayCalculator;
window.HolidayHourlyCalculator = window.HolidayHourlyCalculator || HolidayHourlyCalculator;
window.HolidayPayCalculator = window.HolidayPayCalculator || HolidayPayCalculator;
